import { ComparerCommon, ComparerParam } from '@/types/comparer';
import { isArray } from '@/util/typeGuards';
import { makeParam } from './comparerUtils';

const compareKey = <T>(key: keyof T & string, valueA: T | undefined, valueB: T | undefined): ComparerParam => {
  const keyValueA = valueA?.[key];
  const keyValueB = valueB?.[key];

  if (isArray(keyValueA) && isArray(keyValueB)) {
    const sortedA = keyValueA.map((value) => JSON.stringify(value)).sort();
    const sortedB = keyValueB.map((value) => JSON.stringify(value)).sort();
    const changed = sortedA.length !== sortedB.length || !sortedA.every((value, index) => value === sortedB[index]);
    return makeParam(key, keyValueA, keyValueB, changed);
  }
  return makeParam(key, keyValueA, keyValueB);
};

export const simpleComparer = <T>(
  arrayA: T[],
  arrayB: T[],
  id: keyof T & string,
  label: keyof T & string,
  keys: (keyof T & string)[]
): ComparerCommon[] => {
  const result: ComparerCommon[] = [];
  const mapA = new Map(arrayA.map((item) => [item[id], item]));
  const mapB = new Map(arrayB.map((item) => [item[id], item]));
  const allIds = new Set([...mapA.keys(), ...mapB.keys()]);

  allIds.forEach((value) => {
    const valueA = mapA.get(value);
    const valueB = mapB.get(value);
    const changedProps = keys.map((key) => compareKey(key, valueA, valueB));

    if (valueA && valueB)
      result.push({
        status: changedProps.some((param) => param.changed) ? 'modified' : 'unchanged',
        id: String(valueA[id]),
        label: String(valueA[label]),
        changedProps
      });
    else if (valueA)
      result.push({
        status: 'removed',
        id: String(valueA[id]),
        label: String(valueA[label] || valueA[id]),
        changedProps
      });
    else if (valueB)
      result.push({
        status: 'added',
        id: String(valueB[id]),
        label: String(valueB[label] || valueB[id]),
        changedProps
      });
  });

  return result;
};
